const runtimeConfig: AppRuntimeConfig =
  typeof window !== 'undefined' ? window.__APP_CONFIG__ || {} : {};

export const getRuntimeConfig = (): AppRuntimeConfig => runtimeConfig;

export const getMapboxPublicToken = (): string =>
  getRuntimeConfig().VITE_MAPBOX_PUBLIC_TOKEN || '';

export const getApiBaseUrl = (): string | undefined =>
  getRuntimeConfig().REACT_APP_API_BASE_URL;

export const getClientVersion = (): string =>
  getRuntimeConfig().APP_CLIENT_VERSION || 'dev';
